// Service for uploading images to local API
import { api } from './api';

export interface ImageUploadResponse {
  success: boolean;
  data: {
    display_url: string;
    filename: string;
    size: number;
  };
}

export class ImageUploadService {
  async uploadImage(file: File): Promise<ImageUploadResponse> {
    try {
      const formData = new FormData();
      formData.append('images', file);

      const response = await api.uploadImages(formData);
      
      if (response.data && response.data.files && response.data.files.length > 0) {
        const uploadedFile = response.data.files[0];
        return {
          success: true,
          data: {
            display_url: uploadedFile.original, // original zawiera już zoptymalizowany URL
            filename: uploadedFile.filename,
            size: uploadedFile.size
          }
        };
      } else {
        throw new Error('No files uploaded');
      }
    } catch (error) {
      console.error('Error uploading image:', error);
      throw new Error('Nie udało się przesłać obrazu. Spróbuj ponownie.');
    }
  }

  async uploadBase64(base64Data: string, name?: string): Promise<ImageUploadResponse> {
    try {
      // Konwertuj base64 na File
      const response = await fetch(base64Data);
      const blob = await response.blob();
      const file = new File([blob], name || 'image.png', { type: blob.type });
      
      return await this.uploadImage(file);
    } catch (error) {
      console.error('Error uploading base64 image:', error);
      throw new Error('Nie udało się przesłać obrazu. Spróbuj ponownie.');
    }
  }

  validateFile(file: File): { valid: boolean; error?: string } {
    // Sprawdź typ pliku
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/gif'];
    if (!allowedTypes.includes(file.type)) {
      return {
        valid: false,
        error: 'Dozwolone formaty: JPEG, PNG, WebP, GIF'
      };
    }

    // Sprawdź rozmiar pliku (max 10MB dla lokalnego API)
    const maxSize = 10 * 1024 * 1024; // 10MB
    if (file.size > maxSize) {
      return {
        valid: false,
        error: 'Plik jest za duży. Maksymalny rozmiar: 10MB'
      };
    }

    return { valid: true };
  }
}

export const imageUploadService = new ImageUploadService();
export default imageUploadService;
